import { useEffect, useState } from 'react';
import Modal from '../Modal';
import styles from './OfflineModal.module.scss';

export type OfflineModalType = 'IsOffline' | 'ConfirmSave' | 'Synced';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCancel: () => void;
  className?: string;
  modalType: OfflineModalType;
}

export default function OfflineModal({ isOpen, onClose, modalType, onCancel }: ModalProps) {
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');

  useEffect(() => {
    switch (modalType) {
      case 'IsOffline':
        setTitle('Offline Mode');
        setBody('You are currently offline, so any edits you make will be saved and synced once you are back online.');
        break;
      case 'ConfirmSave':
        setTitle('Offline Mode');
        setBody('You are currently offline, so your changes have been saved and will be synced once you are back online.');
        break;
      case 'Synced':
        setTitle('Updates Synced');
        setBody('Your changes were successfully sent to the server.');
        break;
    }
  }, [modalType]);

  if (!isOpen) return null;

  return (
    <Modal onClose={() => {}} isOpen={true}>
      <div className={styles.header}>{title}</div>
      <div className={styles.content}>{body}</div>
      {modalType == 'IsOffline' && (
        <div className={`${styles.buttonContainer} ${styles.multipleButtons}`}>
          <button type="button" className={`${styles.button} ${styles.cancelButton}`} onClick={onCancel}>
            Cancel
          </button>

          <button type="button" className={`${styles.button} ${styles.quickAddButton}`} onClick={onClose}>
            Continue
          </button>
        </div>
      )}
      {modalType != 'IsOffline' && (
        <div className={`${styles.buttonContainer} ${styles.singleButton}`}>
          <button type="button" className={`${styles.button} ${styles.quickAddButton}`} onClick={onClose}>
            Ok
          </button>
        </div>
      )}
    </Modal>
  );
}
